import type { Country } from '@skippay/core/@types/country';

import {
	ACCOUNT_UPGRADE,
	CASHBACK,
	INSTALLMENTS,
	OVERVIEW,
	PACKAGES,
	PAYMENT_CARD,
	PAYMENT_GATEWAY,
	PAYMENT_PARTIAL,
	PAY_IN_THREE,
	REFERRALS,
	REGISTRATION,
	REWARDS,
	SEND_MONEY,
} from './routes';

export type ClaritySurface = 'selfcare' | 'paygate' | 'mobapp';
export type ClarityEnv = 'prod' | 'accept';

export const CLARITY_PROJECT_IDS: Record<
	ClaritySurface,
	Record<Country, Partial<Record<ClarityEnv, string>>>
> = {
	selfcare: {
		CZ: { prod: 'm5osn0o8w4', accept: 'm64lz4lkx3' },
		SK: { prod: 'nnm2eoxzhn', accept: 'q1fcmgtx89' },
		HU: { prod: 'wy4z3bjqqi', accept: 'wy4zy31so3' },
	},
	paygate: {
		CZ: { prod: 'mnpie7edrx', accept: 'mk4h2oka4o' },
		SK: { prod: 'nnlxdaftm1', accept: 'q1fc57mu1o' },
		HU: { prod: 'wy4zoz0e14', accept: 'wy8a15pbn6' },
	},
	mobapp: {
		CZ: { prod: 'jz5ci41efc', accept: 'lmm5hetwnc' },
		SK: { prod: 'nnm1g5dim9', accept: 'wy7h0mc18e' },
		HU: { prod: 'wy4wq44nsv', accept: '' },
	},
};

export const CLARITY_TRACKED_ROUTES: readonly string[] = [
	REGISTRATION,
	OVERVIEW,
	REWARDS,
	CASHBACK,
	SEND_MONEY,
	PAY_IN_THREE,
	INSTALLMENTS,
	REFERRALS,
	PAYMENT_CARD,
	ACCOUNT_UPGRADE,
	PACKAGES,
	PAYMENT_PARTIAL,
	PAYMENT_GATEWAY,
];
